import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import AdminCreateUserForm from "composer/views/admin/AdminCreateUserForm.jsx"
import AdminCreateSchoolForm from "composer/views/admin/AdminCreateSchoolForm.jsx"
import AdminViewUserSubscription from 'composer/views/admin/AdminViewUserSubscription';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Tabs, Tab, Button, IconButton, Tooltip, TextField, Icon, FormControl, Select, MenuItem, InputLabel } from '@material-ui/core';
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { BorderAll } from '@material-ui/icons';

const MAX_ROW_PER_PAGE = 12;

const styles = {
  userFilter: {
    display:'inline-block',
    verticalAlign:'middle',
    padding: '0 8px',
  },
};

class AdminTaskDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      activeTab: 0,
      searchUserText: "",

      // user list related
      userData: [],
      userIDText: "",
      usernameText: "",
      displayNameText: "",
      userEmailText: "",
      userSchoolIDText: "",
      userRole: [],
      userRoleFilter: 0,
      userOrderBy: 0,
      userOrderType: 0,
      totalPageUser: 0,
      currentPageUser: 0,
      // user list related end

      // school list related
      schoolData: [],
      schoolLocale: [],
      schoolType: [],
      schoolIDText: "",
      schoolNameText: "",
      schoolLocaleFilter: 0,
      schoolKeyText: "",
      schoolTypeFilter: 0,
      schoolOrderBy: 0,
      schoolOrderType: 0,
      totalPageSchool: 0,
      currentPageSchool: 0,
      // school list related end

      tableRows: [],
    };
    autoBind(this);
  }

  refreshUserList() {
    var order_by = "";
    switch(this.state.userOrderBy){
      case 0:
        order_by = "id";
        break;
      case 1:
        order_by = "username";
        break;
      case 2:
        order_by = "display_name";
        break;
      case 4:
        order_by = "role";
        break;
      case 5:
        order_by = "school_id";
        break;
      case 6:
        order_by = "last_login_time";
        break;
      default:
        break;
    }

    var order_type = "";
    switch(this.state.userOrderType){
      case 0:
        order_type = "desc";
        break;
      case 1:
        order_type = "asc";
        break;
      default:
        break;
    }

    var requestObj = {
      order_by: order_by,
      order_type: order_type,
      limit_offset: this.state.currentPageUser * MAX_ROW_PER_PAGE,
      limit_row_count: MAX_ROW_PER_PAGE,
    };

    if(this.state.userIDText != ""){
      requestObj['filter_by_id'] = this.state.userIDText;
    }

    if(this.state.usernameText != ""){
      requestObj['filter_by_username'] = this.state.usernameText;
    }

    if(this.state.displayNameText != ""){
      requestObj['filter_by_display_name'] = this.state.displayNameText;
    }

    if(this.state.userEmailText != ""){
      requestObj['filter_by_email'] = this.state.userEmailText;
    }

    if(this.state.userRoleFilter != 0){
      requestObj['filter_by_role'] = this.state.userRoleFilter - 1;
    }

    if(this.state.userSchoolIDText != ""){
      requestObj['filter_by_school_id'] = this.state.userSchoolIDText;
    }

    // api call
    // get user list
    this.props.root.refs.API.request("get_user_list", requestObj, this.getUserListOK, this.getUserListFailed);

    // get user role
    // api implementation not yet finished
    // insert that api call here
  }

  refreshSchoolList() {
    var order_by = "";
    switch(this.state.schoolOrderBy){
      case 0:
        order_by = "id";
        break;
      case 1:
        order_by = "name";
        break;
      case 2:
        order_by = "name_eng";
        break;
      case 6:
        order_by = "school_type";
        break;
      default:
        break;
    }

    var order_type = "";
    switch(this.state.schoolOrderType){
      case 0:
        order_type = "desc";
        break;
      case 1:
        order_type = "asc";
        break;
      default:
        break;
    }

    var requestObj = {
      order_by: order_by,
      order_type: order_type,
      limit_offset: this.state.currentPageSchool * MAX_ROW_PER_PAGE,
      limit_row_count: MAX_ROW_PER_PAGE,
    };

    if(this.state.schoolIDText != ""){
      requestObj['filter_by_id'] = this.state.schoolIDText;
    }

    if(this.state.schoolNameText != ""){
      requestObj['filter_by_name'] = this.state.schoolNameText;
    }

    if(this.state.schoolKeyText != ""){
      requestObj['filter_by_key'] = this.state.schoolKeyText;
    }

    if(this.state.schoolTypeFilter != ""){
      requestObj['filter_by_type'] = this.state.schoolTypeFilter;
    }

    var locale = "";
    if(this.state.schoolLocaleFilter != 0){
      locale = this.state.schoolLocale[this.state.schoolLocaleFilter-1].locale;
      requestObj['filter_by_locale'] = locale;
    }

    // get school list
    this.props.root.refs.API.request("get_school_list", requestObj, this.getSchoolListOK, this.getSchoolListFailed);

    // get school locale
    this.props.root.refs.API.request("get_school_locale", null, this.getSchoolLocaleOK, this.getSchoolLocaleFailed);

    // get school type
    this.props.root.refs.API.request("get_school_type", null, this.getSchoolTypeOK, this.getSchoolTypeFailed);
  }

  getUserListOK(res){
    console.log("get user list ok");
    // console.log(res);

    let count = res.body['count'];
    let page = Math.ceil(count / MAX_ROW_PER_PAGE);

    this.setState({
      userData: res.body['result'],
      totalPageUser: page,
    });
    this.state.userData = res.body['result'];
    this.state.totalPageUser = page;
  }

  getUserListFailed(res){
    console.log("get user list failed");
  }

  getSchoolListOK(res){
    console.log("get school list ok");
    // console.log(res);

    let count = res.body['count'];
    let page = Math.ceil(count / MAX_ROW_PER_PAGE);
    
    this.setState({
      schoolData : res.body['result'],
      totalPageSchool: page,
    });
    this.state.schoolData = res.body['result'];
    this.state.totalPageSchool = page;
  }

  getSchoolListFailed(res){
    console.log("get school list failed");
  }

  getSchoolLocaleOK(res){
    console.log("get school locale ok");
    console.log(res);

    this.setState({
      schoolLocale : res.body['result'],
    });
    this.state.schoolLocale = res.body['result'];
  }

  getSchoolLocaleFailed(res){
    console.log("getSchoolLocaleFailed");
  }

  getSchoolTypeOK(res){
    console.log("get school type ok");
    // console.log(res);

    this.setState({
      schoolType : res.body['result'],
    });
    this.state.schoolType = res.body['result'];
  }

  getSchoolTypeFailed(res){
    console.log("getSchoolTypeFailed");
  }

  getTasks() {
    return [Localization.strings.CREATE_USER, Localization.strings.USER_LIST, Localization.strings.CREATE_SCHOOL, Localization.strings.SCHOOL_LIST];
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    if (newIndex == index) {
      return;
    }
    newIndex = index;
    this.setState({
      activeTab: newIndex,
      tableRows: [],
    });
    this.state.activeTab = newIndex;
    this.state.tableRows = [];

    switch(this.state.activeTab){
      case 0:
        break;
      case 1:
        this.refreshUserList();
        break;
      case 2:
        break;
      case 3:
        this.refreshSchoolList();
        break;
      default:
        break;
    }
  }

  handleTabChange = (event, index) => {
    this.changeTab(index);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.setState({ activeTab: 0 });
    this.state.activeTab = 0;
    this.close();
  }

  userList() {
    return [
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.userIDText}
          onChange={this.searchUserIDTextChanged}
          label="User ID"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchUserEnterPressed} // enter key press to search is disabled here, it may trigger to 2 search events
          // margin="dense"
        />
      </div>,
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.usernameText}
          onChange={this.searchUsernameTextChanged}
          label="Username"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchUserEnterPressed} // enter key press to search is disabled here, it may trigger to 2 search events
          // margin="dense"
        />
      </div>,
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.displayNameText}
          onChange={this.searchDisplayNameTextChanged}
          label="Display Name"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchUserEnterPressed} // enter key press to search is disabled here, it may trigger to 2 search events
          // margin="dense"
        />
      </div>,
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.userEmailText}
          onChange={this.searchUserEmailTextChanged}
          label="Email"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchUserEnterPressed} // enter key press to search is disabled here, it may trigger to 2 search events
          // margin="dense"
        />
      </div>,
      <div style={styles.userFilter}>
        <FormControl>
          <InputLabel style={{width:"130px",display:"Inline-block"}}>User Role</InputLabel>
          <Select
            value={this.state.userRoleFilter}
            onChange={this.userRoleChanged}
          >
            <MenuItem value={0}>Any</MenuItem>
            <MenuItem value={1}>Student</MenuItem>
            <MenuItem value={2}>Normal User</MenuItem>
            <MenuItem value={3}>Super User</MenuItem>
            <MenuItem value={4}>Admin</MenuItem>
            {/* {
              this.state.userRole.map((row, i) => (
                <MenuItem value={i+1}>{row['name']}</MenuItem>
              ))
            } */}
          </Select>
        </FormControl>
      </div>,
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.userSchoolIDText}
          onChange={this.searchuserSchoolIDTextTextChanged}
          label="School ID"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchUserEnterPressed} // enter key press to search is disabled here, it may trigger to 2 search events
          // margin="dense"
        />
      </div>,
      <Tooltip key="searchTooltip" title={Localization.strings.SEARCH}>
        <IconButton
          onClick={this.handleSearchUserClicked}
        >
          <Icon>search</Icon>
        </IconButton>
      </Tooltip>,
      <Tooltip title={Localization.strings.CLEAR}>
      <IconButton
        onClick={this.handleUserClearClicked}
      >
        <Icon>clear</Icon>
      </IconButton>
    </Tooltip>,
      <Table key="userTable" size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={this.state.userOrderBy == 0}
                direction={this.state.userOrderType == 0 ? 'desc' : 'asc'}
                onClick={this.sortUserHandler(0)}
                >
                編號
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={this.state.userOrderBy == 1}
                direction={this.state.userOrderType == 0 ? 'desc' : 'asc'}
                onClick={this.sortUserHandler(1)}
                >
                帳號名稱
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={this.state.userOrderBy == 2}
                direction={this.state.userOrderType == 0 ? 'desc' : 'asc'}
                onClick={this.sortUserHandler(2)}
                >
                顯示名稱
              </TableSortLabel>
            </TableCell>
            <TableCell>電郵</TableCell>
            <TableCell>
              <TableSortLabel
                active={this.state.userOrderBy == 4}
                direction={this.state.userOrderType == 0 ? 'desc' : 'asc'}
                onClick={this.sortUserHandler(4)}
                >
                權限
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={this.state.userOrderBy == 5}
                direction={this.state.userOrderType == 0 ? 'desc' : 'asc'}
                onClick={this.sortUserHandler(5)}
                >
                學校編號
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={this.state.userOrderBy == 6}
                direction={this.state.userOrderType == 0 ? 'desc' : 'asc'}
                onClick={this.sortUserHandler(6)}
                >
                最近登入
              </TableSortLabel>
            </TableCell>
            <TableCell>禁用</TableCell>
            <TableCell>檢視訂閱</TableCell>
          </TableRow>
          {
            this.state.userData.map((row, i) => {
              return(
                <TableRow>
                  <TableCell>
                    {row["id"]}
                  </TableCell>
                  <TableCell>
                    {row["username"]}
                  </TableCell>
                  <TableCell>
                    {row["display_name"]}
                  </TableCell>
                  <TableCell>
                    {row["email"]}
                  </TableCell>
                  <TableCell>
                    {row["role"]}
                  </TableCell>
                  <TableCell>
                    {row["school_id"]}
                  </TableCell>
                  <TableCell>
                    {row["last_login_time"]}
                  </TableCell>
                  <TableCell>
                    {row["disabled"]}
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={this.viewSubscriptionClicked(row["id"])}
                    >
                      <Icon>search</Icon>
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
          }
        </TableHead>
        <TableBody>
          {
            this.state.tableRows.map((row, i) => (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
            ))
          }
        </TableBody>
      </Table>,
      this.pageUserNavigator()
    ];
  }

  schoolList() {
    return [
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.schoolIDText}
          onChange={this.searchSchoolIDTextChanged}
          label="School ID"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchSchoolEnterPressed}
          // margin="dense"
        />
      </div>,
      <div style={styles.userFilter}>
        <TextField key="searchText"
          value={this.state.schoolNameText}
          onChange={this.searchSchoolNameTextChanged}
          label="School Name / Remark"
          placeholder={Localization.strings.INPUT_KEYWORD}
          InputLabelProps={{ shrink: true }}
          // onKeyPress={this.handleSearchSchoolEnterPressed}
          // margin="dense"
        />
      </div>,
      <div style={styles.userFilter}>
        <FormControl>
          <InputLabel style={{width:"130px",display:"Inline-block"}}>Locale</InputLabel>
          <Select
            value={this.state.schoolLocaleFilter}
            onChange={this.schoolLocaleFilterChanged}
          >
            <MenuItem value={0}>Any</MenuItem>
            {
              this.state.schoolLocale.map((row, i) => (
                <MenuItem value={i+1}>{row['locale']}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </div>,
      <div style={styles.userFilter}>
        <FormControl>
          <InputLabel style={{width:"130px",display:"Inline-block"}}>School Type</InputLabel>
          <Select
            value={this.state.schoolTypeFilter}
            onChange={this.schoolTypeChanged}
          >
            {
              this.state.schoolType.map((row, i) => (
                <MenuItem value={i}>{row['name']}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </div>,
    
      <Tooltip key="searchTooltip" title={Localization.strings.SEARCH}>
        <IconButton
          onClick={this.handleSearchSchoolClicked}
        >
          <Icon>search</Icon>
        </IconButton>
      </Tooltip>,
      <Tooltip title={Localization.strings.CLEAR}>
        <IconButton
          onClick={this.handleSchoolClearClicked}
        >
          <Icon>clear</Icon>
        </IconButton>
      </Tooltip>,
      <Table key="schoolTable" size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
              active={this.state.schoolOrderBy == 0}
              direction={this.state.schoolOrderType == 0 ? 'desc' : 'asc'}
              onClick={this.sortSchoolHandler(0)}
              >
                編號
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
              active={this.state.schoolOrderBy == 1}
              direction={this.state.schoolOrderType == 0 ? 'desc' : 'asc'}
              onClick={this.sortSchoolHandler(1)}
              >
                學校名稱
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
              active={this.state.schoolOrderBy == 2}
              direction={this.state.schoolOrderType == 0 ? 'desc' : 'asc'}
              onClick={this.sortSchoolHandler(2)}
              >
                學校名稱(Eng)
              </TableSortLabel>
            </TableCell>
            <TableCell>
              Remark
            </TableCell>
            <TableCell>
              地區
            </TableCell>
            <TableCell>
              Key
            </TableCell>
            <TableCell>
              <TableSortLabel
              active={this.state.schoolOrderBy == 6}
              direction={this.state.schoolOrderType == 0 ? 'desc' : 'asc'}
              onClick={this.sortSchoolHandler(6)}
              >
                類別
              </TableSortLabel>
            </TableCell>
          </TableRow>
          {
            this.state.schoolData.map((row, i) => {
              return(
                <TableRow>
                  <TableCell>
                    {row["id"]}
                  </TableCell>
                  <TableCell>
                    {row["name"]}
                  </TableCell>
                  <TableCell>
                    {row["name_eng"]}
                  </TableCell>
                  <TableCell>
                    {row["remark"]}
                  </TableCell>
                  <TableCell>
                    {row["locale"]}
                  </TableCell>
                  <TableCell>
                    {row["key"]}
                  </TableCell>
                  <TableCell>
                    {row["school_type"]}
                  </TableCell>
                </TableRow>
              );
            })
          }
        </TableHead>
      </Table>,
      this.pageSchoolNavigator()
    ];
  }

  searchUserIDTextChanged(e) {
    var result = e.target.value.replace(/\D/g, '');
    this.setState({ userIDText: result });
    this.state.userIDText = result;
  }

  searchUsernameTextChanged(e) {
    this.setState({ usernameText: e.target.value });
    this.state.usernameText = e.target.value;
  }

  searchDisplayNameTextChanged(e) {
    this.setState({ displayNameText: e.target.value });
    this.state.displayNameText = e.target.value;
  }

  searchUserEmailTextChanged(e) {
    this.setState({ userEmailText: e.target.value });
    this.state.userEmailText = e.target.value;
  }

  searchuserSchoolIDTextTextChanged(e) {
    this.setState({ userSchoolIDText: e.target.value });
    this.state.userSchoolIDText = e.target.value;
  }

  userRoleChanged(e){
    this.setState({ userRoleFilter: e.target.value });
    this.state.userRoleFilter = e.target.value;
  }

  searchSchoolIDTextChanged(e) {
    var result = e.target.value.replace(/\D/g, '');
    this.setState({ schoolIDText: result });
    this.state.schoolIDText = result;
  }

  searchSchoolNameTextChanged(e) {
    this.setState({ schoolNameText: e.target.value });
    this.state.schoolNameText = e.target.value;
  }

  searchSchoolKeyTextChanged(e) {
    this.setState({ schoolKeyText: e.target.value });
    this.state.schoolKeyText = e.target.value;
  }

  schoolLocaleFilterChanged(e){
    this.setState({ schoolLocaleFilter: e.target.value });
    this.state.schoolLocaleFilter = e.target.value;
  }

  schoolTypeChanged(e){
    this.setState({ schoolTypeFilter: e.target.value });
    this.state.schoolTypeFilter = e.target.value;
  }

  schoolOrderByChanged(e){
    this.setState({ schoolOrderBy: e.target.value });
    this.state.schoolOrderBy = e.target.value;
  }

  schoolOrderTypeChanged(e){
    this.setState({ schoolOrderType: e.target.value });
    this.state.schoolOrderType = e.target.value;
  }

  handleSearchUserClicked() {
    this.setState({ currentPageUser: 0 });
    this.state.currentPageUser = 0;
    this.refreshUserList();
  }

  handleSearchUserEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchUserClicked();
    }
  }

  handleSearchSchoolClicked() {
    this.setState({ currentPageSchool: 0 });
    this.state.currentPageSchool = 0;
    this.refreshSchoolList();
  }

  sortUserHandler = col_ind => event => {
    var sortOrderType = 0;
    if(col_ind == this.state.userOrderBy){
      sortOrderType = this.state.userOrderType == 0 ? 1 : 0;
    }else{
      sortOrderType = 0;
    }

    this.setState({ userOrderType: sortOrderType });
    this.setState({ userOrderBy: col_ind });
    this.state.userOrderType = sortOrderType;
    this.state.userOrderBy = col_ind;

    this.refreshUserList();
  }

  sortSchoolHandler = col_ind => event => {
    // console.log(col_ind);
    var sortOrderType = 0;
    if(col_ind == this.state.schoolOrderBy){
      // if sorting the same col, flip the order
      sortOrderType = this.state.schoolOrderType == 0 ? 1 : 0;
    }else{
      // change the order to desc if sorting a new col
      sortOrderType = 0;
    }

    this.setState({ schoolOrderType: sortOrderType });
    this.setState({ schoolOrderBy: col_ind });
    this.state.schoolOrderType = sortOrderType;
    this.state.schoolOrderBy = col_ind;

    this.refreshSchoolList();
  }

  handleSearchSchoolEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchSchoolClicked();
    }
  }

  handleUserClearClicked(){
    console.log("handleUserClearClicked");

    this.setState(
      {
        userIDText: "",
        usernameText: "",
        displayNameText: "",
        userEmailText: "",
        userSchoolIDText: "",
        userRoleFilter: 0,
        userOrderBy: 0,
        userOrderType: 0,
        currentPageUser: 0,
      }
    );

    this.state.userIDText = "";
    this.state.usernameText = "";
    this.state.displayNameText = "";
    this.state.userEmailText = "";
    this.state.userSchoolIDText = "";
    this.state.userRoleFilter = 0;
    this.state.userOrderBy = 0;
    this.state.userOrderType = 0;
    this.state.currentPageUser = 0;

    this.refreshUserList();
  }

  handleSchoolClearClicked(){
    // clear filter
    this.setState(
      {
        schoolIDText: "",
        schoolNameText: "",
        schoolLocaleFilter: 0,
        schoolKeyText: "",
        schoolTypeFilter: 0,
        schoolOrderBy: 0,
        schoolOrderType: 0,
        currentPageSchool: 0
      }
    );

    this.state.schoolIDText = "";
    this.state.schoolNameText = "";
    this.state.schoolLocaleFilter = 0;
    this.state.schoolKeyText = "";
    this.state.schoolTypeFilter = 0;
    this.state.schoolOrderBy = 0;
    this.state.schoolOrderType = 0;
    this.state.currentPageSchool = 0;
  
    this.refreshSchoolList();
  }

  previosPageUser() {
    let page = this.state.currentPageUser;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePageUser(page);
  }

  nextPageUser() {
    let page = this.state.currentPageUser;
    page++;
    if (page > this.state.totalPageUser - 1) {
      page = this.state.totalPageUser - 1;
    }
    this.changePageUser(page);
  }

  pageChangedUser(e) {
    let page = e.target.value;
    this.setState({ currentPageUser: page});
    this.state.currentPageUser = page;
    this.refreshUserList();
  }

  changePageUser(page){
    this.setState({ currentPageUser: page});
    this.state.currentPageUser = page;
    // console.log(page);
    this.refreshUserList();
  }


  previosPageSchool() {
    let page = this.state.currentPageSchool;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePageSchool(page);
  }

  nextPageSchool() {
    let page = this.state.currentPageSchool;
    page++;
    if (page > this.state.totalPageSchool - 1) {
      page = this.state.totalPageSchool - 1;
    }
    this.changePageSchool(page);
  }

  pageChangedSchool(e) {
    let page = e.target.value;
    this.changePageSchool(page);
  }

  changePageSchool(page){
    this.setState({ currentPageSchool: page});
    this.state.currentPageSchool = page;
    // console.log(page);
    this.refreshSchoolList();
  }

  pageUserNavigator() {
    let pages = [];
    for (let i = 0; i < this.state.totalPageUser; i++) {
      pages.push(i);
    }
    return [
      <div key="page" style={{padding:'0 12px 0 0', display:'inline-block'}}>{Localization.strings.PAGE}</div>,
      <FormControl key="currentPage" margin='dense'>
        <Select
          value={this.state.currentPageUser}
          onChange={this.pageChangedUser}
        >
          {
            pages.map( (page, i) => {
              return (
                <MenuItem key={i} value={i}>{i+1}</MenuItem>
              )
            })
          }
        </Select>
      </FormControl>,
      <IconButton
        onClick={this.previosPageUser}
        disabled={this.state.currentPageUser <= 0}
      >
        <Icon>keyboard_arrow_left</Icon>
      </IconButton>,
      <IconButton
        onClick={this.nextPageUser}
        disabled={this.state.currentPageUser + 1 >= this.state.totalPageUser}
      >
        <Icon>keyboard_arrow_right</Icon>
      </IconButton>
    ];
  }

  pageSchoolNavigator() {
    let pages = [];
    for (let i = 0; i < this.state.totalPageSchool; i++) {
      pages.push(i);
    }
    return [
      <div key="page" style={{padding:'0 12px 0 0', display:'inline-block'}}>{Localization.strings.PAGE}</div>,
      <FormControl key="currentPage" margin='dense'>
        <Select
          value={this.state.currentPageSchool}
          onChange={this.pageChangedSchool}
        >
          {
            pages.map( (page, i) => {
              return (
                <MenuItem key={i} value={i}>{i+1}</MenuItem>
              )
            })
          }
        </Select>
      </FormControl>,
      <IconButton
        onClick={this.previosPageSchool}
        disabled={this.state.currentPageSchool <= 0}
      >
        <Icon>keyboard_arrow_left</Icon>
      </IconButton>,
      <IconButton
        onClick={this.nextPageSchool}
        disabled={this.state.currentPageSchool + 1 >= this.state.totalPageSchool}
      >
        <Icon>keyboard_arrow_right</Icon>
      </IconButton>
    ];
  }

  viewSubscriptionClicked = user_id => event => {
    console.log("view this user_id subscription: " + user_id);

    this.refs.adminViewUserSubscription.setState(
      {
        open: true,
        user_id: user_id,
      }
    );
    this.refs.adminViewUserSubscription.state.open = true;
    this.refs.adminViewUserSubscription.state.user_id = user_id;

    this.refs.adminViewUserSubscription.refreshSubscriptionHistoryList();
  }

  render() {
    let tasks = this.getTasks();
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.ADMIN_TASK}
          </DialogTitle>

          <DialogContent>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              style={{padding:'0 0 14px 0'}}
            >
              {tasks.map((label, index) => {
                return (
                  <Tab key={index} label={label}/>
                );
              })}
            </Tabs>
            <Switch condition={this.state.activeTab}>
              <Case value={0}>
                <AdminCreateUserForm parent={this} root={this.props.root} refs="adminCreateUserForm" />
              </Case>
              <Case value={1}>
                {this.userList()}
              </Case>
              <Case value={2}>
                <AdminCreateSchoolForm parent={this} root={this.props.root} refs="adminCreateSchoolForm" />
              </Case>
              <Case value={3}>
                {this.schoolList()}
              </Case>
            </Switch>
          </DialogContent>

          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleClose}
            >
              {Localization.strings.DONE}
            </Button>
          </DialogActions>
        </Dialog>
        <AdminViewUserSubscription parent={this} root={this.props.root} ref="adminViewUserSubscription"/>
      </div>
    )
  }
}

export default AdminTaskDialog;
